import { ngame } from './index'

// 공통 필터 메서드 적용 
import { checkLimitedUser } from './function/method'

function fetchInfomation (option) {
  return ngame.post('/lotto/information.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchAdCheck (option) {
  return ngame.post('/lotto/adCheck.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function adTypeCheck (option) {
  return ngame.post('/lotto/adTypeCheck.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function requestCreate (option) {
  return ngame.post('/lotto/create.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchTicket (option) {
  return ngame.post('/lotto/ticket.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function requestUse (option) {
  return ngame.post('/lotto/use.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchJoinList (option) {
  return ngame.post('/lotto/joinList.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchPrevJoinList (option) {
  return ngame.post('/lotto/prevJoinList.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchMyJoinList (option) {
  return ngame.post('/lotto/myJoinList.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchMyPrevJoinList (option) {
  return ngame.post('/lotto/myPrevJoinList.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function fetchWinnerInfo (option) {
  return ngame.post('/lotto/winnerInfo.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

function requestMission (option) {
  return ngame.post('/lotto/mission.do',option)
  .then((res) => {
    return checkLimitedUser(res)
  });
}

export { fetchInfomation, fetchAdCheck, adTypeCheck, requestCreate, fetchTicket, requestUse, fetchJoinList, fetchPrevJoinList, fetchMyJoinList, fetchMyPrevJoinList, fetchWinnerInfo, requestMission }